import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { SC_Input } from '../../../common/input/SC_Input';
import { MountingSystem } from '../../../common/mountsys/MountingSystem';
import { RoofItemType } from '../../../common/mountsys/roofItemType';
import { Sol50Integrated } from '../../../common/mountsys/Sol50Integrated';
import { Sol50OnRoof } from '../../../common/mountsys/Sol50OnRoof';
import { RoofParameterService } from "../../../common/roof/roof-parameter.service";
import { SC_Beam } from '../../../common/roof/SC_Beam';
import { GlobalService } from "../../../common/services/global.service";
import { SC_CableClip } from '../../../common/stocklist/roofhook/SC_CableClip';
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { TranslateService } from "../../../common/variables/translate-service";
import { clearSelectedPlan } from '../../../store/senAppProjects.action';

@Component({
  selector: 'sen-app-roof-item-list',
  templateUrl: './roof-item-list.component.html',
  styleUrls: ['./roof-item-list.component.scss']
})
export class RoofItemListComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  inverterPath: string;
  selectedProject$: Observable<any[]>;
  selectedProjectUnSubscibe: Subscription;
  selectedProject: any;
  itemList: any[] = [];
  constructor(private routerPath: RouterPathService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    public global: GlobalVariableService,
    public globalService: GlobalService,
    private store: Store<any>,
    private router: Router,
    private roofParams: RoofParameterService) {
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPPanelString}`;
    this.nextPath = this.routerPath.MPProjectPath;
    this.inverterPath = this.routerPath.IPSearchInverterPath;
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.selectedProjectUnSubscibe = this.selectedProject$.subscribe((data: any) => {
      this.selectedProject = data;
    });
  }

  ngOnInit(): void {
    try {
      this.loadPage();
    } catch (err) {
      console.log(err)
    }
  }

  ngOnDestroy() {
    this.selectedProjectUnSubscibe.unsubscribe();
  }

  loadPage() {
    let uvTmp: any = {};
    var sTmp: RoofItemType[];
    sTmp = MountingSystem.getStocklist();
    // Cable clip
    sTmp.push(new RoofItemType(NaN, SC_CableClip.sVariable, SC_CableClip.determineAmount()));

    //distance adapter
    if (SC_Input.bInRoof) {
      uvTmp.distadap = Sol50Integrated.getDistAdap().toString();
    } else {
      if (SC_Input.bBeam) {
        if (SC_Input.iBeamType == SC_Beam.PURLIN) {
          if (SC_Input.sStosch) {
            sTmp.push(new RoofItemType(SC_Input.sStoschID.senItemID, '', Sol50OnRoof.getStoSch()));
          }
        }
      }
      uvTmp.distadap = Sol50OnRoof.getDistAdap().toString();
    }
    sTmp = sTmp.filter((i: RoofItemType) => i.quantity); //skips 0 amount
    let option = {
      panelID: SC_Input.sModulID,
      panelQty: SC_Input.iModulCount,
      items: sTmp
    }
    this.getPlanItemList(option);
  }


  getPlanItemList(option: any) {
    const qParam = {
      cmd: this.global.RoofPlanItemList
    };
    this.globalService.postData(qParam, option).subscribe((data: any) => {
      try {
        if (data && data.ok) {
          SC_Input.roofPlanItems = [];
          this.itemList = data.ok.data;
          data.ok.data.items.forEach((i: any) => {
            SC_Input.roofPlanItems.push({ senItemID: i.senItemID, quantity: i.quantity });
          });
        }
      } catch { }
    })
  }

  roofPlanSave(path: string) {
    let option = this.roofParams.setRoofParams();
    const qParam = {
      cmd: this.global.RoofPlanSave
    };
    this.globalService.postData(qParam, option).subscribe(data => {
      try {
        if (data && data.ok) {
          this.router.navigate([path], {
            state: { action: this.global.savePlan }
          });
        }
      } catch { } finally {
        this.router.navigate([path], {
          state: { action: this.global.savePlan }
        });
        this.store.dispatch(clearSelectedPlan());
      }
    });
  }
}

/*
private getWRTGStocklist(): string {
  var i: number;
  var sRet: string;
  var wrTmp: WR;
  var nTmp: number;
  sRet = "";
  SC_Input.aInvAssign.forEach(wrTmp => {
    sRet += wrTmp.sID + ":1|";
    if (wrTmp.iWRCabCnt > 0) {
      sRet += wrTmp.sWRCabId + ":" + wrTmp.iWRCabCnt.toString() + "|";
    }
    if (wrTmp.iModCabCnt > 0) {
      sRet += wrTmp.sModCabId + ":" + wrTmp.iModCabCnt.toString() + "|";
    }
    if (wrTmp.iErdCnt > 0) {
      sRet += wrTmp.sErdId + ":" + wrTmp.iErdCnt.toString() + "|";
    }
    i = 0;
    wrTmp.aEingang.forEach((wreingangTmp: WREingang) => {
      wreingangTmp.aString.forEach((wrstringTmp: WRString) => {
        nTmp = (wrstringTmp.nCabLen * 2);
        if (nTmp > 0) {
          sRet += wrstringTmp.sCab + ":" + nTmp.toString() + "|";
        }
      });
      i++;
    });
    sRet += "|";
    for (i = 0; i < wrTmp.aDCSV.length; i++) {
      sRet += wrTmp.aDCSV[i][0] + ":" + wrTmp.aDCSV[i][1] + "|";
    }
  });
  return sRet;
}

private getWRDCSic(): string {
  var sRet: string = '';
  var wreingangTmp: WREingang;
  var iUsedSlots: number = 0;
  var bSV: Boolean;
  var sTmp: string;
  var iStrFactor: number = 1;
  var i: number;
  for (i = 0; i < SC_Input.aInvAssign.length; i++) {
    bSV = false;
    for (let j = 0; j < SC_Input.aInvAssign[i].aDCSV.length; j++) {
      if (SC_Input.aInvAssign[i].aDCSV[j].aTmp[2]) {
        bSV = true;
        break;
      }
    };
    if (!bSV) {
      continue;
    }
    for (i = 0; i < SC_Input.aInvAssign[i].aEingang.length; i++) {
      wreingangTmp = SC_Input.aInvAssign[i].aEingang[i];
      iUsedSlots += SC_DC.calcSlots(wreingangTmp.aString.length, iStrFactor);
    }
  };
  if (iUsedSlots > 0) {
    sRet += SC_Input.sModulID + ":" + iUsedSlots.toString() + "|";
  }
  return sRet;
}

private getACOVPStockList(): string {
  var i: number;
  var acovpitemCurrent: ACOVPItem;
  var sRet: string = "";
  for (i = 0; i < SC_Input.acovplistCurrent.length; i++) {
    acovpitemCurrent = SC_Input.acovplistCurrent.getItemByIndex(i);
    sRet += acovpitemCurrent.sItemNo + ":" + acovpitemCurrent.iCnt.toString() + "|";
  }
  return sRet;
}

private getWRCollectStrCnt(): string {
  var i: number;
  var sRet: string = "";
  var sTmp: string;
  var oTmp: any;
  SC_Input.aInvAssign.forEach((wrTmp: WR) => {
    wrTmp.aEingang.forEach((wreingangTmp: WREingang) => {
      i = wreingangTmp.aString.length;
      if (i > 0) {
        if (oTmp[i.toString()] != null) {
          oTmp[i.toString()][1]++;
        } else {
          oTmp[i.toString()] = [wrTmp.sID, 1];
        }
      }
    });
  });
  for (sTmp in oTmp) {
    sRet += sTmp + ":" + oTmp[sTmp][0] + ":" + oTmp[sTmp][1] + "|";
  }
  return sRet;
}
*/
